import React, { useEffect, useState } from "react";
import { Card, Grid, List, ListItem, ListItemText, Avatar, Divider } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";


import PropTypes from "prop-types";
const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toISOString().slice(0, 10).split("-").reverse().join("-");
};
const styles = {
  iconstyle: {
    color: "gray",
  },
  projectTitle: {
    color: "gray",
  },
};
const ProjectManagers = ({ projectManager }) => {
  return (
    <MDBox>
      <Card sx={{ overflow: "visible", p: 3 }}>
        <Grid item xs={12} md={12}>
          <MDBox>
            <MDTypography variant="h6" fontWeight="bold" mb={1}>
              &nbsp; مديرو المشروع
            </MDTypography>
            <List sx={{ mt: 2 }} style={styles?.projectTitle}>
              {projectManager.length > 0 ? (
                projectManager.map((manager, index) => (
                  <ListItem key={index} sx={{ alignItems: "flex-start" }}>
                    <Avatar>{manager.displayName ? manager.displayName[0] : "N/A"}</Avatar>
                    <ListItemText
                      primary={
                        <MDTypography variant="body1" fontWeight="bold">
                          {manager.displayName || "بدون اسم"}
                        </MDTypography>
                      }
                      secondary={manager.email || "بدون بريد إلكتروني"}
                    />
                  </ListItem>
                ))
              ) : (
                <MDTypography variant="body2" color="text.secondary">
                  لا يوجد مديرين للمشروع حالياً
                </MDTypography>
              )}
            </List>
          </MDBox>
        </Grid>
      </Card>
    </MDBox>
  );
};

ProjectManagers.propTypes = {
  projectManager: PropTypes.array,
};
export default ProjectManagers;
